import t from "@ext/localization/locale/translate";
import { DropdownMenuItem } from "@ui-kit/Dropdown";
import { Loader } from "@ui-kit/Loader";
import { TextOverflowTooltip } from "@ui-kit/Tooltip";
import { TREE_INDENT_STEP } from "@ui-kit/Tree";
import { type ComponentProps, forwardRef, type ReactNode } from "react";

type ProviderPickerRowProps = {
	title: string;
	depth?: number;
	leading?: ReactNode;
	note?: ReactNode;
	rowTestId?: string;
};

export const ProviderPickerRow = ({ title, depth = 0, leading, note, rowTestId }: ProviderPickerRowProps) => {
	const titleText = <TextOverflowTooltip className="block w-full min-w-0 flex-1">{title}</TextOverflowTooltip>;

	return (
		<div
			className="flex min-w-0 flex-1 items-center gap-2"
			data-testid={rowTestId}
			style={{ paddingLeft: depth * TREE_INDENT_STEP }}
		>
			{leading}
			{note ? (
				<div className="flex min-w-0 flex-1 flex-col">
					{titleText}
					{note}
				</div>
			) : (
				titleText
			)}
		</div>
	);
};

type ProviderPickerItemProps = ProviderPickerRowProps & ComponentProps<typeof DropdownMenuItem>;

export const ProviderPickerItem = forwardRef<HTMLDivElement, ProviderPickerItemProps>(
	({ title, depth, leading, note, rowTestId, children, ...itemProps }, ref) => (
		<DropdownMenuItem ref={ref} textValue={title} {...itemProps}>
			<ProviderPickerRow depth={depth} leading={leading} note={note} rowTestId={rowTestId} title={title} />
			{children}
		</DropdownMenuItem>
	),
);

ProviderPickerItem.displayName = "ProviderPickerItem";

export const ProviderPickerLoading = () => (
	<DropdownMenuItem disabled>
		<div className="flex items-center gap-2">
			<Loader size="sm" />
			{t("loading")}
		</div>
	</DropdownMenuItem>
);
